
import { uidMixin } from "../../mixins/uidMixin"
export default {
  inject: {
    segmentedGroup: {
      default: null
    }
  },
  mixins: [uidMixin],
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /* Currently selected value sent by v-model */
    modelValue: {
      type: [String, Object, Boolean],
      default: ""
    },
    /* Value when checked */
    value: {
      type: [String, Object, Boolean],
      default: ""
    },
    name: {
      type: String,
      default: "",
      required: true
    },
    label: {
      type: String,
      default: null,
      required: true
    },
    inputId: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    tracking: {
      type: [Object, Array],
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    wrap: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    binding: {
      get() {
        return this.selectedGroupValue
      },
      set(value) {
        this.inGroup
          ? this.segmentedGroup.checked(value)
          : this.$emit("change", value)
      }
    },
    buttonClasses() {
      return {
        "segmented-button--small": this.small,
        "segmented-button--wrap": this.wrap,
        primary: this.variant === "primary"
      }
    },
    inGroup() {
      return Boolean(this.segmentedGroup)
    },
    selectedGroupValue() {
      return this.inGroup ? this.segmentedGroup.selectedValue : this.modelValue
    }
  }
}
